// React
import React from "react";

// Libraries
import PropTypes from "prop-types";

// Components
import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const TextContent = ({ item }) => {
	return (
		<Text className={styles.text} withMarkdown>
			{item.text}
		</Text>
	);
};

TextContent.propTypes = {
	item: PropTypes.object,
};

export default TextContent;
